<script>
import {defineComponent} from 'vue'
import api from "@/api/api"
import {isTeamWinner} from "@/common/isTeamWinner";
import {countryFlag} from "@/common/countryFlag";
import MlbbMatchStats from "@/components/modals/MlbbMatchStats.vue"
import MlbbSeriesTabs from "@/components/modals/MlbbSeriesTabs.vue"
import MlbbSeriesGameWaiting from "@/components/modals/MlbbSeriesGameWaiting.vue"
import {connectToWs, onMessage, subscribe, unsubscribe} from "@/services/websocket"

const SERIES_TARGET_WINS = { bo1: 1, bo3: 2 }
const SERIES_MAX_GAMES = { bo1: 1, bo3: 3 }

export default defineComponent({
  name: "OpenGridMatch",
  components: { MlbbMatchStats, MlbbSeriesTabs, MlbbSeriesGameWaiting },
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isShowEditBtns: false,
      editableTeams: [],
      isSavingScore: false,
      isLoading: false,
      isSaveAttempted: false,
      selectedWinnerIndex: null,
      selectedGroupResultId: null,
      losingTeams: [],
      isLoadingLosingTeams: false,
      selectedLosingTeam: null,
      isAddingTeam: false,
      isStartingAutomation: false,
      isAutomationStarted: false,
      isCheckingAutomation: false,
      automationMatch: null,
      timerMinutes: 5,
      isSavingTimer: false,
      approvingAlertId: null,
      resolvingAlertId: null,
      wsChannel: null,
      wsUnsubscribe: null,
      activeGameNumber: 1,
      userTouchedTab: false,
    }
  },
  methods: {
    isTeamWinner,
    selectWinner(teamIndex, groupResultId) {
      this.selectedWinnerIndex = teamIndex
      this.selectedGroupResultId = groupResultId
      this.editableTeams.forEach((team, index) => {
        team.isWinner = index === teamIndex
      })
    },
    selectLosingTeam(team) {
      this.selectedLosingTeam = team
    },
    async deleteTeamFromGroup(team) {
      // Валидация: проверяем наличие groupId и teamId
      const groupId = this.matchData.group_id
      const teamId = team.id

      if (!groupId || !teamId) {
        this.$bvToast.toast('ID группы или команды не найден', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      // Подтверждение удаления
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Вы уверены, что хотите удалить команду "${team.name}" из этого матча?`,
        {
          title: 'Подтверждение удаления',
          okVariant: 'danger',
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          centered: true
        }
      )

      if (!confirmed) {
        return
      }

      try {
        this.isLoading = true

        await api.grid.deleteTeamFromGroup(groupId, teamId)

        this.$bvToast.toast(`Команда "${team.name}" успешно удалена из группы`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
          autoHideDelay: 2000
        })

        // Обновляем данные сетки
        this.$emit('getGrids')
        this.$emit('handleCloseModal')
      } catch (e) {
        console.error('Ошибка при удалении команды из группы:', e)
        this.$bvToast.toast(e.response?.data?.message || 'Ошибка при удалении команды из группы', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
      } finally {
        this.isLoading = false
      }
    },
    async addTeamToGroup() {
      // Валидация: проверяем, что команда выбрана
      if (!this.selectedLosingTeam) {
        this.$bvToast.toast('Пожалуйста, выберите проигравшую команду', {
          title: 'Ошибка',
          variant: 'warning',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      // Валидация: проверяем наличие groupId
      const groupId = this.matchData.group_id
      if (!groupId) {
        this.$bvToast.toast('ID группы не найден', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      try {
        this.isAddingTeam = true

        const teamId = this.selectedLosingTeam.id

        await api.grid.addTeamToGroup(groupId, teamId)

        this.$bvToast.toast(`Команда "${this.selectedLosingTeam.name}" успешно добавлена в группу`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
          autoHideDelay: 2000
        })

        // Сбрасываем выбранную команду
        this.selectedLosingTeam = null

        // Обновляем данные сетки
        this.$emit('getGrids')
        this.$emit('handleCloseModal')
      } catch (e) {
        console.error('Ошибка при добавлении команды в группу:', e)
        this.$bvToast.toast(e.response?.data?.message || 'Ошибка при добавлении команды в группу', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
      } finally {
        this.isAddingTeam = false
      }
    },
    async getLosingTeams() {
      try {
        this.isLoadingLosingTeams = true
        const stageId = this.$props.params.stageId
        const upperGridTeamCount = this.$props.params.upperGridTeamCount
        const lowerGridTeamCount = this.$props.params.lowerGridTeamCount

        if (!stageId) {
          console.error('stageId не найден в params')
          return
        }

        const res = await api.grid.getLosingTeams(stageId, {
          upper_grid_team_count: upperGridTeamCount,
          lower_grid_team_count: lowerGridTeamCount
        })

        console.log('Проигравшие команды:', res.data)
        this.losingTeams = res.data.data || []
        return res.data
      } catch (e) {
        console.error('Ошибка при получении проигравших команд:', e)
        this.losingTeams = []
      } finally {
        this.isLoadingLosingTeams = false
      }
    },
    async handleAssignTechDefeat(team) {
      if (this.isLoading) return
      this.isLoading = true
      try {
        const assignedTeam = this.displayTeams.find(t => t.group_team_id !== team?.group_team_id)
        if (this.automationMatch?.id) {
          await api.grid.advanceMlbbAutomation(this.automationMatch.id, {
            group_team_id: assignedTeam.group_team_id,
            is_wo: true
          })
        } else {
          await api.tournamentGroupResult.sendWinner(assignedTeam.group_team_id, {
            is_wo: true
          })
        }
        this.$bvToast.toast('Техническое поражение успешно сохранено', {
          title: 'Сохранено',
          variant: 'success',
          solid: true,
          autoHideDelay: 2000
        })
        this.$emit('handleCloseModal', {})
        this.$emit('getGrids', {})
      } catch (error) {
        console.error('Ошибка при назначении технического поражения:', error)

        // Запрос мог долететь до backend несмотря на ошибку/таймаут — принудительно
        // перечитываем сетку и закрываем модалку, чтобы админ не отправил ТП
        // повторно на устаревшем состоянии (это привело бы к дублю команды).
        this.$emit('getGrids')
        this.$bvToast.toast(
          (error.response?.data?.message || error.message || 'Ошибка при назначении технического поражения') +
            '. Проверьте актуальное состояние сетки перед повторной попыткой.',
          {
            title: 'Ошибка',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          }
        )
        this.$emit('handleCloseModal')
      } finally {
        this.isLoading = false
      }
    },
    handleEdit() {
      if (this.$props.params.nodeData?._key) {
        this.isShowEditBtns = !this.isShowEditBtns
        if (this.isShowEditBtns) {
          this.editableTeams = this.teams.map(team => ({
            ...team,
            editScore: team.score || 0
          }))
          const winnerIndex = this.teams.findIndex(team => team.isWinner)
          this.selectedWinnerIndex = winnerIndex !== -1 ? winnerIndex : null
        }
      }
    },

    incrementScore(teamIndex) {
      if (teamIndex >= 0 && teamIndex < this.editableTeams.length) {
        const currentTeam = this.editableTeams[teamIndex]

        // Увеличиваем счет до максимума 4
        if (currentTeam.editScore < 4) {
          currentTeam.editScore++
        }
      }
    },

    decrementScore(teamIndex) {
      if (teamIndex >= 0 && teamIndex < this.editableTeams.length) {
        const currentTeam = this.editableTeams[teamIndex]

        // Уменьшаем счет до минимума 0
        if (currentTeam.editScore > 0) {
          currentTeam.editScore--
        }
      }
    },
    async saveChanges() {
      if (this.isLoading || this.isSaveAttempted) return
      this.isSaveAttempted = true
      this.isLoading = true
      try {
        if (this.selectedWinnerIndex !== null && this.selectedWinnerIndex !== undefined) {
          await this.saveScore()
          if (this.selectedGroupResultId) {
            if (this.automationMatch?.id) {
              await api.grid.advanceMlbbAutomation(
                this.automationMatch.id,
                { group_team_id: this.selectedGroupResultId },
                { skipSuccessToast: true }
              )
            } else {
              await api.tournamentGroupResult.sendWinner(
                this.selectedGroupResultId,
                undefined,
                { skipSuccessToast: true }
              )
            }
          }
          this.$bvToast.toast('Результаты и победитель сохранены', {
            title: 'Сохранено',
            variant: 'success',
            solid: true,
            autoHideDelay: 2000
          })
        } else {
          this.editableTeams.forEach(team => {
            team.isWinner = false
          })
          await this.saveScore()
        }

        // Обновляем локальные данные
        this.teams.forEach((team, index) => {
          team.score = this.editableTeams[index].editScore
          team.isWinner = this.editableTeams[index].isWinner
        })

        this.isShowEditBtns = false

        // Сначала обновляем сетку, затем закрываем модалку
        this.$emit('getGrids')
        this.$emit('handleCloseModal')

      } catch (error) {
        console.error('Ошибка при сохранении результатов:', error)

        // Запрос мог долететь до backend несмотря на ошибку/таймаут — принудительно
        // перечитываем сетку и закрываем модалку, чтобы админ увидел актуальное
        // состояние и не отправил sendWinner повторно (это привело бы к дублю
        // команды в ячейке следующего раунда).
        this.$emit('getGrids')
        this.$bvToast.toast(
          (error.response?.data?.message || error.message || 'Ошибка при сохранении') +
            '. Проверьте актуальное состояние сетки перед повторной попыткой.',
          {
            title: 'Ошибка',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          }
        )
        this.$emit('handleCloseModal')
      } finally {
        this.isLoading = false
      }
    },

    async saveScore() {
      try {
        for (let index = 0; index < this.editableTeams.length; index++) {
          const editableTeam = this.editableTeams[index]
          await api.tournamentGroupResult.addData(
            this.editableTeams[index]?.group_result_id,
            { winPoint: editableTeam.editScore },
            { skipSuccessToast: true }
          )
        }

        this.teams.forEach((team, index) => {
          team.score = this.editableTeams[index].editScore
        })
      } catch (error) {
        console.error('Ошибка при сохранении счета:', error)

        this.$bvToast.toast(error.response?.data?.message || error.message || 'Ошибка при сохранении счета', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
        throw error
      } finally {
        this.isSavingScore = false
      }
    },
    cancelEdit() {
      this.isShowEditBtns = false
      this.editableTeams = []
    },
    ownerContacts(contacts) {
      const list = contacts || []
      const telegrams = list.filter(c => c.provider === 'telegram' && c.username)
      if (telegrams.length) return telegrams
      return list.filter(c => c.provider === 'discord' && (c.username || c.provider_id))
    },
    contactHref(contact) {
      if (contact.provider === 'telegram') return `https://t.me/${contact.username}`
      if (contact.provider === 'discord') return `https://discord.com/users/${contact.provider_id}`
      return null
    },
    contactDisplay(contact) {
      if (contact.provider === 'telegram') return `@${contact.username}`
      if (contact.provider === 'discord') return contact.username ? `@${contact.username}` : `id: ${contact.provider_id}`
      return ''
    },
    contactLabel(contact) {
      if (contact.provider === 'telegram') return 'Telegram'
      if (contact.provider === 'discord') return 'Discord'
      return contact.provider
    },
    countryFlag,
    async checkAutomationStatus() {
      const groupId = this.matchData.group_id
      if (!groupId) return

      try {
        this.isCheckingAutomation = true
        const res = await api.grid.getMlbbMatch(groupId)
        this.automationMatch = res?.data?.data || null
        this.isAutomationStarted = !!this.automationMatch
      } catch (e) {
        this.automationMatch = null
        this.isAutomationStarted = false
      } finally {
        this.isCheckingAutomation = false
      }
    },
    subscribeToMatchSocket(groupId) {
      if (!groupId || this.wsChannel) return

      connectToWs()
      this.wsUnsubscribe = onMessage((msg) => this.handleSocketMessage(msg))

      this.wsChannel = `mlbb-matches.${groupId}`
      subscribe(this.wsChannel, localStorage.getItem('token'))
    },
    handleSocketMessage(msg) {
      if (!msg || !msg.event) return
      const groupId = this.matchData.group_id

      switch (msg.event) {
        case 'mlbb-match.state-changed': {
          const next = msg.data?.mlbb_match
          if (!next) return
          if (groupId && next.group_id && next.group_id !== groupId) return
          // create_lobby_url не приходит в бродкасте — сохраняем из текущего стейта
          const prevCreateLobbyUrl = this.automationMatch?.create_lobby_url || null
          // participants в бродкасте могут приходить без name — мерджим с текущим стейтом по user_id
          const prevParticipants = this.automationMatch?.participants || []
          const mergedParticipants = (next.participants || prevParticipants).map(p => {
            const prev = prevParticipants.find(x => x.user_id === p.user_id)
            return { ...prev, ...p, name: p.name ?? prev?.name }
          })
          // alerts в state-changed могут не приходить — сохраняем из текущего стейта,
          // чтобы поднятые алерты (rehost/result/appeal) не пропадали до alert-resolved
          const prevAlerts = this.automationMatch?.alerts || []
          const nextAlerts = next.alerts != null ? next.alerts : prevAlerts
          this.automationMatch = {
            ...next,
            create_lobby_url: next.create_lobby_url ?? prevCreateLobbyUrl,
            participants: mergedParticipants,
            alerts: nextAlerts,
          }
          this.isAutomationStarted = true
          break
        }
        case 'mlbb-match.alert-raised': {
          const alert = msg.data?.mlbb_match_alert
          if (!alert) return
          if (groupId && alert.group_id && alert.group_id !== groupId) return
          const prevAlerts = this.automationMatch?.alerts || []
          const alertId = alert.id
          const withoutDup = alertId != null
              ? prevAlerts.filter(a => a?.id !== alertId)
              : prevAlerts
          this.automationMatch = {
            ...(this.automationMatch || {}),
            alerts: [...withoutDup, alert],
          }
          this.isAutomationStarted = true
          break
        }
        case 'mlbb-match.alert-resolved': {
          const alert = msg.data?.mlbb_match_alert
          if (!alert) return
          if (groupId && alert.group_id && alert.group_id !== groupId) return
          const prevAlerts = this.automationMatch?.alerts || []
          const alertId = alert.id
          this.automationMatch = {
            ...(this.automationMatch || {}),
            alerts: alertId != null ? prevAlerts.filter(a => a?.id !== alertId) : prevAlerts,
          }
          break
        }
        default:
          break
      }
    },
    unsubscribeFromMatchSocket() {
      if (this.wsChannel) {
        unsubscribe(this.wsChannel)
        this.wsChannel = null
      }
      if (typeof this.wsUnsubscribe === 'function') {
        this.wsUnsubscribe()
        this.wsUnsubscribe = null
      }
    },
    async approveRehost(alert) {
      const automationId = this.automationMatch?.id
      if (!automationId) {
        this.$bvToast.toast('ID автоматизации не найден', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      try {
        this.approvingAlertId = alert.id
        await api.grid.approveMlbbRehost(automationId)
        this.$bvToast.toast('Рехост одобрен. Лобби сброшено, новые ссылки сгенерированы.', {
          title: 'Успешно',
          variant: 'success',
          solid: true,
          autoHideDelay: 2500
        })
        await this.checkAutomationStatus()
      } catch (e) {
        console.error('Ошибка при одобрении рехоста:', e)
        this.$bvToast.toast(e.response?.data?.message || e.message || 'Ошибка при одобрении рехоста', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
      } finally {
        this.approvingAlertId = null
      }
    },
    async resolveAlert(alert) {
      if (!alert?.id) {
        this.$bvToast.toast('ID алерта не найден', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      try {
        this.resolvingAlertId = alert.id
        await api.grid.resolveMlbbAlert(alert.id)
        this.$bvToast.toast('Алерт снят', {
          title: 'Успешно',
          variant: 'success',
          solid: true,
          autoHideDelay: 2500
        })
        await this.checkAutomationStatus()
      } catch (e) {
        console.error('Ошибка при снятии алерта:', e)
        this.$bvToast.toast(e.response?.data?.message || e.message || 'Ошибка при снятии алерта', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
      } finally {
        this.resolvingAlertId = null
      }
    },
    async setAutomationTimer() {
      const automationId = this.automationMatch?.id
      const phase = this.automationTimerPhase
      const minutes = Number(this.timerMinutes)

      if (!automationId || !phase) {
        this.$bvToast.toast('Текущая фаза матча не позволяет редактировать таймер', {
          title: 'Внимание',
          variant: 'warning',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      if (!Number.isFinite(minutes) || minutes < 1 || minutes > 120) {
        this.$bvToast.toast('Минуты должны быть от 1 до 120', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      try {
        this.isSavingTimer = true
        await api.grid.setMlbbAutomationTimer(automationId, { phase, minutes })
        this.$bvToast.toast(`Таймер фазы «${this.automationTimerPhaseLabel}» обновлён (+${minutes} мин)`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
          autoHideDelay: 2000
        })
        await this.checkAutomationStatus()
      } catch (e) {
        console.error('Ошибка при обновлении таймера:', e)
        this.$bvToast.toast(e.response?.data?.message || e.message || 'Ошибка при обновлении таймера', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
      } finally {
        this.isSavingTimer = false
      }
    },
    async startAutomation() {
      const groupId = this.matchData.group_id
      if (!groupId) {
        this.$bvToast.toast('ID группы не найден', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      try {
        this.isStartingAutomation = true
        await api.grid.startMlbbAutomation(groupId)
        this.isAutomationStarted = true
        this.$bvToast.toast('Автоматизация матча запущена', {
          title: 'Успешно',
          variant: 'success',
          solid: true,
          autoHideDelay: 2000
        })
        await this.checkAutomationStatus()
      } catch (e) {
        console.error('Ошибка при запуске автоматизации:', e)
        this.$bvToast.toast(e.response?.data?.message || e.message || 'Ошибка при запуске автоматизации', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000
        })
      } finally {
        this.isStartingAutomation = false
      }
    },
    handleSelectGame(gameNumber) {
      this.userTouchedTab = true
      this.activeGameNumber = gameNumber
    },
    teamParticipants(team) {
      const groupTeamId = team?.group_team_id
      if (groupTeamId == null) return []
      return this.automationParticipants.filter(p => p.group_team_id === groupTeamId)
    },
    async handleRollback(groupTeamId) {
      if (!this.onRollback) {
        this.$bvToast.toast('Функция отката не определена', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 2000
        })
        return
      }

      try {
        this.isLoading = true

        if (!groupTeamId) {
          this.$bvToast.toast('ID группы не найден', {
            title: 'Ошибка',
            variant: 'danger',
            solid: true,
            autoHideDelay: 2000
          })
          return
        }

        // Вызываем функцию отката из родительского компонента
        // Родительский компонент сам покажет уведомление и закроет модалку
        await this.onRollback(groupTeamId)
      } catch (error) {
        console.error('Ошибка при откате:', error)
      } finally {
        this.isLoading = false
      }
    },
  },
  computed: {
    matchData() {
      return this.params.nodeData || {}
    },
    onScoreUpdate() {
      return this.params.onScoreUpdated || (() => {
        console.warn('⚠️ No callback function provided!');
      })
    },
    onRollback() {
      return this.params.onRollback || null
    },
    teams() {
      const basicTeams = this.matchData.teams || []
      const originalTeams = this.matchData.originalTeams || []
      return basicTeams.map((team, index) => ({
        ...team,
        ...(originalTeams[index] || {})
      }))
    },
    matchName() {
      return this.matchData.name || 'Матч'
    },
    displayTeams() {
      return this.isShowEditBtns ? this.editableTeams : this.teams
    },
    hasChanges() {
      if (!this.isShowEditBtns) return false
      return this.editableTeams.some((team, index) =>
          team.editScore !== (this.teams[team.id]?.score || 0) ||
          team.isWinner !== this.teams[team.id]?.isWinner
      )
    },
    isLowerBracket() {
      return this.params.isLowerBracket || false
    },
    isMatchCompleted() {
      return this.teams.some(team => {
        if (team?.isWinner) return true
        if (team?.result_fields?.is_winner === 1) return true
        if ((team?.result_fields?.winner_matches_count || 0) > 0) return true
        return (team?.score || 0) > 0
      })
    },
    hasAutomationResults() {
      if (!this.automationMatch) return false
      const firstGame = this.seriesGames[0]
      return Boolean(
          this.automationMatch.winner_group_team_id
          || (firstGame?.result_players && firstGame.result_players.length)
      )
    },
    showMatchStats() {
      if (!this.activeGameMatchData) return false
      if (this.isBo3 && this.activeSlot?.status === 'completed') return true
      if (this.isActiveTabCurrent && this.hasAutomationResults) return true
      return false
    },
    automationRosters() {
      if (!this.automationMatch) return null

      const { host_group_team_id, guest_group_team_id, participants = [] } = this.automationMatch

      const buildSide = (groupTeamId) => {
        const teamMeta = this.teams.find(t => t.group_team_id === groupTeamId)
        return {
          groupTeamId,
          name: teamMeta?.name || '',
          participants: participants.filter(p => p.group_team_id === groupTeamId)
        }
      }

      return {
        host: buildSide(host_group_team_id),
        guest: buildSide(guest_group_team_id)
      }
    },
    automationParticipants() {
      return this.automationMatch?.participants || []
    },
    automationStatus() {
      return String(this.automationMatch?.status || '').toLowerCase()
    },
    automationStatusLabel() {
      const map = {
        check_in: 'Чек-ин',
        lobby_wait: 'Ожидание лобби',
        live: 'Идёт игра',
        pending_admin: 'Ждёт подтверждения',
        completed: 'Завершён',
        cancelled: 'Отменён'
      }
      return map[this.automationStatus] || this.automationStatus || ''
    },
    automationStatusVariant() {
      const map = {
        check_in: 'info',
        lobby_wait: 'primary',
        live: 'success',
        pending_admin: 'warning',
        completed: 'secondary',
        cancelled: 'dark'
      }
      return map[this.automationStatus] || 'secondary'
    },
    automationTimerPhase() {
      const status = this.automationStatus
      if (status === 'check_in') return 1
      if (status === 'lobby_wait') return 2
      return null
    },
    automationTimerPhaseLabel() {
      if (this.automationTimerPhase === 1) return 'Чек-ин'
      if (this.automationTimerPhase === 2) return 'Лобби'
      return ''
    },
    automationTimerDeadline() {
      if (this.automationTimerPhase === 1) return this.automationMatch?.check_in_deadline_at || null
      if (this.automationTimerPhase === 2) return this.automationMatch?.lobby_deadline_at || null
      return null
    },
    automationTimerDeadlineFormatted() {
      const raw = this.automationTimerDeadline
      if (!raw) return ''
      const d = new Date(raw)
      if (isNaN(d.getTime())) return ''
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    matchFormat() {
      return this.automationMatch?.format === 'bo3' ? 'bo3' : 'bo1'
    },
    isBo3() {
      return this.matchFormat === 'bo3'
    },
    series() {
      return this.automationMatch?.series || null
    },
    seriesTargetWins() {
      return SERIES_TARGET_WINS[this.matchFormat] || 1
    },
    seriesMaxGames() {
      return SERIES_MAX_GAMES[this.matchFormat] || 1
    },
    seriesGames() {
      return this.series?.games || []
    },
    seriesHostScore() {
      return this.series?.score?.host || 0
    },
    seriesGuestScore() {
      return this.series?.score?.guest || 0
    },
    seriesWinnerGroupTeamId() {
      return this.series?.winner_group_team_id ?? null
    },
    isSeriesResolved() {
      return this.seriesWinnerGroupTeamId != null
    },
    currentGameNumber() {
      if (this.isSeriesResolved) return this.seriesMaxGames
      return Math.min(this.seriesGames.length + 1, this.seriesMaxGames)
    },
    seriesSlots() {
      if (!this.isBo3) return []
      const gamesByNumber = new Map()
      this.seriesGames.forEach((game) => {
        gamesByNumber.set(game.game_number, game)
      })
      const slots = []
      for (let n = 1; n <= this.seriesMaxGames; n += 1) {
        const played = gamesByNumber.get(n)
        if (played) {
          slots.push({
            game_number: n,
            status: 'completed',
            winner_group_team_id: played.winner_group_team_id ?? null,
            result_players: played.result_players || []
          })
          continue
        }
        if (this.isSeriesResolved) {
          slots.push({
            game_number: n,
            status: 'not_needed',
            winner_group_team_id: null,
            result_players: []
          })
          continue
        }
        slots.push({
          game_number: n,
          status: n === this.currentGameNumber ? 'current' : 'waiting',
          winner_group_team_id: null,
          result_players: []
        })
      }
      return slots
    },
    defaultActiveGameNumber() {
      if (!this.isBo3) return 1
      const lastCompleted = this.seriesGames[this.seriesGames.length - 1]
      if (this.isSeriesResolved) {
        return lastCompleted?.game_number ?? this.currentGameNumber
      }
      const isNextGameActive = ['check_in', 'lobby_wait', 'live'].includes(this.automationStatus)
      if (lastCompleted && !isNextGameActive) {
        return lastCompleted.game_number
      }
      return this.currentGameNumber
    },
    activeSlot() {
      if (!this.isBo3) return null
      return this.seriesSlots.find(s => s.game_number === this.activeGameNumber) || null
    },
    isActiveTabCurrent() {
      return !this.isBo3 || this.activeSlot?.status === 'current'
    },
    activeGameMatchData() {
      if (!this.automationMatch) return null
      if (!this.isBo3) {
        return {
          ...this.automationMatch,
          result_players: this.seriesGames[0]?.result_players || []
        }
      }
      if (!this.activeSlot || this.activeSlot.status === 'current') {
        return this.automationMatch
      }
      return {
        ...this.automationMatch,
        winner_group_team_id: this.activeSlot.winner_group_team_id,
        result_players: this.activeSlot.result_players
      }
    },
    seriesWinnerTeamName() {
      if (!this.isSeriesResolved) return ''
      const id = this.seriesWinnerGroupTeamId
      const team = (this.teams || []).find(t => t.group_team_id === id)
      return team?.name || ''
    },
    hostTeamNameForSeries() {
      const id = this.automationMatch?.host_group_team_id
      if (id == null) return ''
      const team = (this.teams || []).find(t => t.group_team_id === id)
      return team?.name || ''
    },
    guestTeamNameForSeries() {
      const id = this.automationMatch?.guest_group_team_id
      if (id == null) return ''
      const team = (this.teams || []).find(t => t.group_team_id === id)
      return team?.name || ''
    },
    automationAlerts() {
      const alerts = this.automationMatch?.alerts || []
      return alerts.map((alert, idx) => {
        const type = String(alert.type || alert.kind || '').toLowerCase()
        let variant = 'info'
        let title = 'Алерт'
        if (type.includes('rehost')) { variant = 'rehost'; title = 'Запрос на рехост' }
        else if (type.includes('appeal')) { variant = 'appeal'; title = 'Подана апелляция' }
        else if (type.includes('timeout')) { variant = 'timeout'; title = 'Таймаут' }
        else if (type.includes('result')) { variant = 'result'; title = 'Результат матча' }

        const payload = alert.payload || {}

        return {
          id: alert.id ?? `alert-${idx}`,
          type,
          variant,
          title,
          author: alert.author_name || alert.author?.name || alert.captain_name || alert.user_name
              || payload.captain_name || payload.author_name || payload.user_name || '',
          reason: alert.reason || alert.description || alert.message
              || payload.reason || payload.description || payload.message || '',
          screenshot: alert.screenshot_url || alert.screenshot || alert.image_url
              || payload.screenshot_url || payload.screenshot || payload.image_url || '',
          raw: alert
        }
      })
    }
  },
  watch: {
    defaultActiveGameNumber: {
      handler(next) {
        if (!this.userTouchedTab) {
          this.activeGameNumber = next
        }
      },
      immediate: true
    },
    'matchData.group_id'() {
      this.userTouchedTab = false
      this.activeGameNumber = this.defaultActiveGameNumber
    }
  },
  mounted() {
    this.getLosingTeams()
    // Подписываемся на канал матча до проверки статуса автоматизации,
    // чтобы получать state-changed даже если автоматизация ещё не запущена на клиенте
    this.subscribeToMatchSocket(this.matchData.group_id)
    this.checkAutomationStatus()
  },
  beforeDestroy() {
    this.unsubscribeFromMatchSocket()
  }
})
</script>

<template>
  <div class="match-modal">
    <div v-if="isAutomationStarted && automationMatch" class="automation-status-bar">
      <span class="status-label">Статус матча:</span>
      <b-badge :variant="automationStatusVariant" class="status-badge">
        {{ automationStatusLabel || '—' }}
      </b-badge>
      <span v-if="isBo3" class="series-format-pill">BO3</span>
      <span
          v-if="isBo3 && isSeriesResolved"
          class="series-format-pill series-format-pill--finished"
      >
        Серия завершена
      </span>
      <span
          v-else-if="isBo3"
          class="series-format-pill series-format-pill--current"
      >
        Счёт серии {{ seriesHostScore }}:{{ seriesGuestScore }}
      </span>
    </div>

    <div v-if="isBo3 && isSeriesResolved && seriesWinnerTeamName" class="series-winner-banner">
      <span class="series-winner-banner__icon" aria-hidden="true">🏆</span>
      <span class="series-winner-banner__text">Победитель серии: {{ seriesWinnerTeamName }}</span>
    </div>

    <MlbbSeriesTabs
        v-if="isBo3 && automationMatch"
        :slots="seriesSlots"
        :active-game-number="activeGameNumber"
        :host-group-team-id="automationMatch.host_group_team_id"
        :guest-group-team-id="automationMatch.guest_group_team_id"
        :host-team-name="hostTeamNameForSeries"
        :guest-team-name="guestTeamNameForSeries"
        @select="handleSelectGame"
    />

    <MlbbSeriesGameWaiting
        v-if="isBo3 && activeSlot && (activeSlot.status === 'waiting' || activeSlot.status === 'not_needed')"
        :game-number="activeSlot.game_number"
        :status="activeSlot.status"
        :host-score="seriesHostScore"
        :guest-score="seriesGuestScore"
        :host-team-name="hostTeamNameForSeries"
        :guest-team-name="guestTeamNameForSeries"
        :target-wins="seriesTargetWins"
    />

    <div v-if="automationAlerts.length" class="alerts-container">
      <div
          v-for="alert in automationAlerts"
          :key="`alert-${alert.id}`"
          :class="['alert-card', `alert-${alert.variant}`]"
      >
        <div class="alert-main">
          <div class="alert-head">
            <span class="alert-dot" />
            <span class="alert-title">{{ alert.title }}</span>
            <span v-if="alert.author" class="alert-author">— {{ alert.author }}</span>
          </div>
          <div v-if="alert.reason" class="alert-reason">
            <span class="alert-reason-label">Причина:</span> {{ alert.reason }}
          </div>
          <a
              v-if="alert.screenshot"
              :href="alert.screenshot"
              target="_blank"
              rel="noopener"
              class="alert-screenshot"
          >
            <i class="fa fa-image" aria-hidden="true" /> Скриншот
          </a>
        </div>
        <div class="alert-actions">
          <b-button
              v-if="alert.variant === 'rehost'"
              variant="warning"
              size="sm"
              @click="approveRehost(alert)"
              :disabled="approvingAlertId === alert.id"
          >
            <b-spinner small v-if="approvingAlertId === alert.id"></b-spinner>
            {{ approvingAlertId === alert.id ? 'Одобрение...' : 'Одобрить рехост' }}
          </b-button>
          <b-button
              variant="outline-secondary"
              size="sm"
              @click="resolveAlert(alert)"
              :disabled="resolvingAlertId === alert.id"
          >
            <b-spinner small v-if="resolvingAlertId === alert.id"></b-spinner>
            {{ resolvingAlertId === alert.id ? 'Снятие...' : 'Снять алерт' }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="teams-container">
      <div
          v-for="(team, index) in displayTeams"
          :key="`team-id-modal-${index}`"
          :class="['team-card', {
          'winner': isTeamWinner(team, displayTeams),
          'loser': !isTeamWinner(team, displayTeams) && displayTeams.some(t => isTeamWinner(t, displayTeams)),
          'editing': isShowEditBtns
        }]"
      >
        <div v-if="isShowEditBtns" class="team-checkbox">
          <b-form-radio
              v-if="displayTeams.every(team => team?.isWinner === false)"
              :value="team.id"
              v-model="selectedWinnerIndex"
              @change="selectWinner(team.id, team.group_team_id)"
              :disabled="isLoading || isSavingScore"
          >
            Победитель
          </b-form-radio>
        </div>
        <div class="team-header">
          <div class="team-name">{{ team.name }}</div>
          <div class="team-header-right">
            <span v-if="isTeamWinner(team, displayTeams)" class="status winner-text">
              Победитель
            </span>
            <span v-else-if="displayTeams.some(t => isTeamWinner(t, displayTeams))" class="status loser-text">
              <b v-if="team.result_fields.is_wo">Техническое</b> Поражение
            </span>
            <div v-if="ownerContacts(team.contacts).length" class="team-contacts-inline">
              <div class="team-contacts-title">Контакты владельца заявки</div>
              <ul class="team-contacts-list">
                <li v-for="(contact, cIdx) in ownerContacts(team.contacts)"
                    :key="`contact-${team.id}-${cIdx}`"
                    class="team-contact-item">
                  <span class="team-contact-provider">{{ contactLabel(contact) }}:</span>
                  <a :href="contactHref(contact)"
                     target="_blank"
                     rel="noopener noreferrer"
                     class="team-contact-value">
                    {{ contactDisplay(contact) }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="team-score">
          <span class="score-label">{{ isShowEditBtns ? 'Счет' : 'Счет' }}</span>

          <!-- Обычные контролы счета -->
          <div v-if="isShowEditBtns" class="score-controls">
            <b-button
                size="sm"
                variant="outline-secondary"
                @click="decrementScore(index)"
                :disabled="isLoading || isSavingScore || team.editScore <= 0"
            >
              -
            </b-button>
            <span class="score-value">{{ team.editScore }}</span>
            <b-button
                size="sm"
                variant="outline-secondary"
                @click="incrementScore(index)"
                :disabled="isLoading || isSavingScore || team.editScore >= 4"
            >
              +
            </b-button>
          </div>

          <!-- Просто отображение счета -->
          <span v-else class="score-value">{{ team.score || 0 }}</span>
        </div>

        <div v-if="isActiveTabCurrent && !hasAutomationResults && teamParticipants(team).length" class="team-players">
          <div
              v-for="player in teamParticipants(team)"
              :key="`player-${team.group_team_id}-${player.user_id}`"
              class="team-player-row"
          >
            <div class="team-player-left">
              <span v-if="countryFlag(player.country_code)"
                    class="player-flag"
                    :title="player.country_name || player.country_code">{{ countryFlag(player.country_code) }}</span>
              <span class="player-name">{{ player.name }}</span>
              <span v-if="player.is_captain" class="cap-badge">CAP</span>
            </div>
            <div class="team-player-right">
              <span :class="['pill', player.is_ready ? 'pill-ready' : 'pill-not-ready']">
                {{ player.is_ready ? '✓ Готов' : '✕ Не готов' }}
              </span>
              <span v-if="player.is_host" class="pill pill-host">🔥 Создал (хост)</span>
              <span v-else-if="player.joined_lobby" class="pill pill-joined">🔗 Подключился</span>
              <span v-else class="pill pill-waiting">Ждёт</span>
            </div>
          </div>
        </div>

        <div class="d-flex flex-wrap gap-2">
          <b-button variant="danger"
                    v-if="matchData.children?.length > 0 && displayTeams.every(team => team?.isWinner === false) || params.nodeData.next_round_id === null"
                    :disabled="isLoading"
                    @click="handleRollback(team?.group_team_id)"
          >
            Откатить
          </b-button>
          <b-button class="ml-1" variant="danger" @click="handleAssignTechDefeat(team)"
                    :disabled="isLoading"
                    v-if="isShowEditBtns && displayTeams.length === 2">
            Назначить ТП
          </b-button>
          <b-button
            class="ml-1"
            variant="danger"
            v-if="isLowerBracket && displayTeams.length > 0 && displayTeams.every(t => !t.isWinner)"
            :disabled="isLoading"
            @click="deleteTeamFromGroup(team)"
          >
            Удалить из матча
          </b-button>
        </div>

      </div>
    </div>
    
    <div v-if="displayTeams.length === 0" class="empty-state">
      <p>Команды еще не определены</p>
    </div>

    <div v-if="automationTimerPhase" class="timer-control">
      <div class="timer-info">
        <span class="timer-label">Активная фаза:</span>
        <span class="timer-phase-badge">{{ automationTimerPhaseLabel }}</span>
        <span v-if="automationTimerDeadlineFormatted" class="timer-deadline">
          до {{ automationTimerDeadlineFormatted }}
        </span>
      </div>
      <div class="timer-actions">
        <span class="timer-actions-label">Новый дедлайн = сейчас +</span>
        <b-form-input
            v-model.number="timerMinutes"
            type="number"
            min="1"
            max="120"
            size="sm"
            class="timer-input"
            :disabled="isSavingTimer"
        />
        <span class="timer-actions-unit">мин (1–120)</span>
        <b-button
            variant="primary"
            size="sm"
            class="ml-2"
            @click="setAutomationTimer"
            :disabled="isSavingTimer || !timerMinutes || timerMinutes < 1 || timerMinutes > 120"
        >
          <b-spinner small v-if="isSavingTimer"></b-spinner>
          {{ isSavingTimer ? 'Сохранение...' : 'Установить' }}
        </b-button>
      </div>
    </div>

    <MlbbMatchStats
        v-if="showMatchStats"
        :match-data="activeGameMatchData"
        :teams="teams"
        :game-number="isBo3 && activeSlot ? activeSlot.game_number : null"
    />

    <!-- Секция с проигравшими командами -->
    <div v-if="losingTeams.length > 0 && displayTeams.length <= 1 && isLowerBracket" class="losing-teams-section">
      <h4 class="losing-teams-title">Проигравшие команды</h4>
      <div class="losing-teams-list">
        <div
            v-for="team in losingTeams"
            :key="`losing-team-${team.id}`"
            :class="['losing-team-item', { 'selected': selectedLosingTeam?.id === team.id }]"
            @click="selectLosingTeam(team)"
        >
          <div class="losing-team-info">
            <span class="losing-team-name">{{ team.name }}</span>
            <span class="losing-team-slug">{{ team.slug }}</span>
          </div>
          <div v-if="selectedLosingTeam?.id === team.id" class="selected-badge">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>
      </div>
      <div>
        <b-button
          class="w-100 mt-3"
          variant="primary"
          @click="addTeamToGroup"
          :disabled="!selectedLosingTeam || isAddingTeam"
        >
          <b-spinner small v-if="isAddingTeam"></b-spinner>
          {{ isAddingTeam ? 'Добавление...' : 'Добавить' }}
        </b-button>
      </div>
    </div>

    <!-- Индикатор загрузки -->
    <div v-else-if="isLoadingLosingTeams" class="loading-state">
      <b-spinner small></b-spinner>
      <span>Загрузка проигравших команд...</span>
    </div>

    <div class="modal-actions">
      <template v-if="!isShowEditBtns">
        <b-button
            variant="primary"
            @click="handleEdit"
            v-if="displayTeams.length > 0 && displayTeams.every(team => team?.isWinner === false)"
            :disabled="isLoading"
        >
          Определить победителя
        </b-button>
        <b-button
            :variant="isAutomationStarted ? 'secondary' : 'success'"
            class="ml-2"
            @click="startAutomation"
            v-if="matchData.group_id && (isAutomationStarted || !isMatchCompleted)"
            :disabled="isStartingAutomation || isCheckingAutomation || isAutomationStarted || isLoading"
        >
          <b-spinner small v-if="isStartingAutomation || isCheckingAutomation"></b-spinner>
          <template v-if="isCheckingAutomation">Проверка...</template>
          <template v-else-if="isAutomationStarted">Матч запущен</template>
          <template v-else-if="isStartingAutomation">Запуск...</template>
          <template v-else>Запустить автоматизацию для матча</template>
        </b-button>
      </template>

      <template v-else>
        <div class="edit-actions">
          <div class="left-actions">

          </div>
          <div class="save-cancel-btns">
            <b-button
                @click="cancelEdit"
                variant="outline-danger">
              Отменить
            </b-button>
            <b-button
                variant="success"
                @click="saveChanges"
                :disabled="isLoading || isSavingScore || isSaveAttempted || !hasChanges"
            >
              <b-spinner small v-if="isLoading"></b-spinner>
              {{ isLoading ? 'Сохранение...' : 'Сохранить все' }}
            </b-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">

.match-modal {
  padding: 10px 0;

  .match-header {
    display: flex;
    justify-content: end;
    align-items: center;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;

    .match-status {
      .status-badge {
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 0.85rem;
        font-weight: 500;
        background: #7366ff;
        color: white;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }
  }

  .status {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 500;
    font-size: 0.9rem;

    &.winner-text {
      color: #28a745;
      animation: pulse-text 2s ease-in-out infinite;
    }

    &.loser-text {
      color: #dc3545;
    }
  }

  .teams-container {
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    margin-bottom: 25px;

    .team-card {
      display: grid;
      grid-template-rows: auto auto 1fr auto;
      background: white;
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border: 2px solid transparent;
      transition: all 0.3s ease;
      position: relative;
      overflow: hidden;

      &.winner {
        transform: scale(1.02);
        border: 2px solid #28a745 !important;

        &::before {
          background: linear-gradient(90deg, #28a745, #20c997);
        }
      }

      &.loser {
        opacity: 0.7;
        transform: scale(0.98);
        border: 2px solid #dc3545 !important;
      }
    }

    &.editing {
      border-color: #007bff;

      &::before {
        background: linear-gradient(90deg, #007bff, #0056b3);
      }
    }

    .team-header {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: start;
      gap: 12px;
      margin-bottom: 15px;
      min-height: 68px;

      .team-name {
        font-size: 1.2rem;
        font-weight: 600;
        color: #2c3e50;
        line-height: 1.3;
        align-self: center;
        min-width: 0;
        word-break: break-word;
      }

      .team-header-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 6px;
        text-align: right;
        min-width: 0;

        .status {
          display: block;
          white-space: nowrap;
          font-weight: 600;
          font-size: 0.9rem;
        }
      }

      .team-contacts-inline {
        text-align: right;

        .team-contacts-title {
          font-size: 0.7rem;
          color: #6c757d;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 4px;
          white-space: nowrap;
        }

        .team-contacts-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .team-contact-item {
          display: inline-flex;
          gap: 4px;
          font-size: 0.85rem;
          line-height: 1.3;
          color: #495057;
          justify-content: flex-end;
        }

        .team-contact-provider {
          color: #6c757d;
        }

        .team-contact-value {
          color: #007bff;
          text-decoration: none;
          word-break: break-all;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .team-badge {
        i {
          color: #ffd700;
          font-size: 1.3rem;
          animation: bounce 1s ease-in-out;
        }
      }
    }

    .team-players {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-bottom: 15px;

      .team-player-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        padding: 8px 10px;
        border: 1px solid #eef0f5;
        border-radius: 8px;
        background: #fff;
      }

      .team-player-left {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;

        .player-name {
          font-weight: 600;
          color: #1f2330;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .team-player-right {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
        justify-content: flex-end;
      }

      .cap-badge {
        background: #1f2330;
        color: #fff;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.6px;
        padding: 2px 6px;
        border-radius: 4px;
      }

      .pill {
        font-size: 11px;
        font-weight: 600;
        padding: 4px 10px;
        border-radius: 999px;
        white-space: nowrap;
      }

      .pill-ready {
        background: #e3f7ea;
        color: #1f9b54;
      }

      .pill-not-ready {
        background: #f1f2f6;
        color: #6b6f7c;
      }

      .pill-host {
        background: #fff4d6;
        color: #b6821a;
      }

      .pill-joined {
        background: #e6efff;
        color: #2b6dff;
      }

      .pill-waiting {
        background: #f1f2f6;
        color: #6b6f7c;
      }
    }

    .team-score {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      padding: 10px;
      background: #f8f9fa;
      border-radius: 8px;

      .score-label {
        font-size: 0.9rem;
        color: #6c757d;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .score-value {
        font-size: 1.5rem;
        font-weight: bold;
        color: #495057;
      }

      .score-controls {
        display: flex;
        align-items: center;
        gap: 10px;

        .btn {
          min-width: 30px;
          height: 30px;
          padding: 0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .score-value {
          min-width: 40px;
          text-align: center;
          font-size: 1.2rem;
        }
      }
    }

    .team-status {
      .edit-btns {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;

        .winner-btn {
          font-size: 0.85rem;
          padding: 6px 12px;

          &.btn-success {
            animation: glow 2s ease-in-out infinite alternate;
          }
        }

        .btn {
          min-width: 35px;

          i {
            font-size: 0.8rem;
          }
        }
      }
    }
  }
}

.vs-divider {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  pointer-events: none;

  .vs-text {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 8px 16px;
    border-radius: 50%;
    font-weight: bold;
    font-size: 0.9rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 3px solid white;
  }
}

.match-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;

  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    .info-label {
      font-weight: 500;
      color: #6c757d;
    }

    .info-value {
      color: #495057;

      &.winner-highlight {
        color: #28a745;
        font-weight: 600;
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;

    i {
      font-size: 3rem;
      margin-bottom: 15px;
      opacity: 0.5;
    }

    p {
      margin: 0;
      font-size: 1.1rem;
    }
  }

  .modal-actions {
    padding-top: 20px;
    border-top: 1px solid #e9ecef;

    .btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 16px;
      border-radius: 8px;
      transition: all 0.3s ease;

      i {
        font-size: 0.9rem;
      }
    }

    .edit-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      flex-wrap: wrap;
      gap: 15px;

      .left-actions {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
      }
    }
  }
}

.save-cancel-btns {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.losing-teams-section {
  margin: 25px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e0e0e0;

  .losing-teams-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #dc3545;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #dc3545;
  }

  .losing-teams-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 12px;

    .losing-team-item {
      background: white;
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      transition: all 0.2s ease;
      cursor: pointer;
      position: relative;

      &:hover {
        border-color: #dc3545;
        box-shadow: 0 2px 8px rgba(220, 53, 69, 0.1);
        transform: translateY(-2px);
      }

      &.selected {
        border-color: #007bff;
        box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);

        .losing-team-name {
          color: #007bff;
        }
      }

      .losing-team-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding-right: 30px;

        .losing-team-name {
          font-size: 0.95rem;
          font-weight: 600;
          color: #2c3e50;
          transition: color 0.2s ease;
        }

        .losing-team-slug {
          font-size: 0.85rem;
          color: #6c757d;
        }
      }

      .selected-badge {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #007bff;
        font-size: 1.2rem;
        animation: fadeIn 0.3s ease;

        i {
          animation: pulse 1.5s ease-in-out infinite;
        }
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-50%) scale(0.5);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  color: #6c757d;
  font-size: 0.9rem;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes glow {
  from {
    box-shadow: 0 0 5px rgba(40, 167, 69, 0.5);
  }
  to {
    box-shadow: 0 0 20px rgba(40, 167, 69, 0.8);
  }
}

@keyframes pulse-text {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

// Адаптивность
@media (max-width: 768px) {
  .match-modal {
    .teams-container {
      grid-template-columns: 1fr;
    }

    .vs-divider {
      position: static;
      transform: none;
      text-align: center;
      margin: 10px 0;
    }

    .modal-actions {
      .edit-actions {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;

        .left-actions {
          justify-content: center;
          width: 100%;

          .btn {
            flex: 1;
            min-width: 120px;
          }
        }

      }

      .btn {
        width: 100%;
        justify-content: center;
      }
    }

    .team-card .team-status .edit-btns {
      flex-direction: column;

      .winner-btn {
        width: 100%;
      }
    }
  }
}

.automation-status-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 16px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid #e9ecef;

  .status-label {
    font-size: 0.85rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  .status-badge {
    font-size: 0.85rem;
    padding: 5px 10px;
  }
}

.series-format-pill {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 999px;
  background: #e6efff;
  color: #2b6dff;

  &--current {
    background: #f1f2f6;
    color: #495057;
  }

  &--finished {
    background: #fff4d6;
    color: #b6821a;
  }
}

.series-winner-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px 20px;
  border-radius: 10px;
  background: linear-gradient(135deg, #fff4d6 0%, #fde3a0 100%);
  border: 1px solid #f6c453;
  color: #7a5202;

  &__icon {
    font-size: 20px;
  }

  &__text {
    font-weight: 700;
    font-size: 14px;
    letter-spacing: 0.3px;
  }
}

.alerts-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 16px;

  .alert-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 12px 16px;
    border-radius: 10px;
    border: 1px solid transparent;
    background: #fff;
    animation: alert-pulse 2.4s ease-in-out infinite;

    &.alert-rehost {
      --alert-color: #b6821a;
      --alert-bg: #fff4d6;
      --alert-border: #f6c453;
      --alert-dot: #f6c453;
    }
    &.alert-appeal {
      --alert-color: #b3142a;
      --alert-bg: #ffe7eb;
      --alert-border: #f08597;
      --alert-dot: #e54860;
    }
    &.alert-timeout {
      --alert-color: #b45a0e;
      --alert-bg: #ffe9d2;
      --alert-border: #f4a45e;
      --alert-dot: #ff8a3d;
    }
    &.alert-result {
      --alert-color: #1f9b54;
      --alert-bg: #e3f7ea;
      --alert-border: #7fd4a0;
      --alert-dot: #2bc275;
    }
    &.alert-info {
      --alert-color: #2b6dff;
      --alert-bg: #e6efff;
      --alert-border: #a9c4ff;
      --alert-dot: #2b6dff;
    }

    background: var(--alert-bg);
    border-color: var(--alert-border);
    color: var(--alert-color);
  }

  .alert-main {
    flex: 1;
    min-width: 0;
  }

  .alert-head {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 700;
    font-size: 14px;

    .alert-dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: var(--alert-dot);
      box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.6);
      animation: alert-blink 1.4s ease-in-out infinite;
    }

    .alert-author {
      font-weight: 500;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .alert-reason {
    margin-top: 4px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.7);

    .alert-reason-label {
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin-right: 4px;
    }
  }

  .alert-screenshot {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    font-size: 12px;
    font-weight: 600;
    color: var(--alert-color);
    text-decoration: underline;

    &:hover {
      opacity: 0.85;
    }
  }

  .alert-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
}

@keyframes alert-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(0, 0, 0, 0); }
  50% { box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.05); }
}

@keyframes alert-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.timer-control {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #fff7e6;
  border: 1px solid #f6c453;
  border-radius: 10px;

  .timer-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .timer-label {
      font-size: 13px;
      color: #6b6f7c;
    }

    .timer-phase-badge {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      padding: 4px 10px;
      border-radius: 6px;
      background: #f6c453;
      color: #5a3d00;
    }

    .timer-deadline {
      font-size: 12px;
      color: #6b6f7c;
      font-variant-numeric: tabular-nums;
    }
  }

  .timer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    .timer-actions-label {
      font-size: 12px;
      color: #6b6f7c;
    }

    .timer-actions-unit {
      font-size: 12px;
      color: #6b6f7c;
    }

    .timer-input {
      width: 72px;
    }
  }
}

</style>